import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Sobre from "@/pages/Sobre";
import ServicePage from "@/pages/ServicePage";
import Contato from "@/pages/Contato";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/sobre" element={<Sobre />} />
                        <Route
                            path="/aluguel-de-veiculos"
                            element={<ServicePage slug="aluguel" />}
                        />
                        <Route
                            path="/rastreamento-veicular"
                            element={<ServicePage slug="rastreamento" />}
                        />
                        <Route
                            path="/guincho-24-horas"
                            element={<ServicePage slug="guincho" />}
                        />
                        <Route path="/contato" element={<Contato />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </div>
    );
}

export default App;
